<block-ui></block-ui>
<div class="card" [formGroup]="FormParameters">
  <div class="card-body">
    <h5 class="card-title">{{ParametersGroup.sys_vc_description}}</h5>
    <fieldset class="col-12">
      <legend>Registro</legend>
      <div class="card">
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-md-8">
              <label>Descripción</label>
              <input type="text" class="form-control" formControlName="sys_vc_description" />
            </div>
            <div class="form-group col-md-4">
                <label>Referencia</label>
                <input type="text" class="form-control" formControlName="sys_vc_references" />
              </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-10">
              <label>Valor</label>
              <input type="text" class="form-control" formControlName="sys_tx_value"  />
            </div>
            <div class="form-group col-md-2">
              <label>&nbsp;</label>
              <button class="btn btn-badminton btn-sm pull-right" (click)="Save()">Guardar</button>
            </div>
          </div>

        </div>
      </div>
    </fieldset>

    
    <fieldset class="col-12">
      <legend>Listado</legend>

      <div class="card">
        <div class="card-body">

          <div class="mat-elevation-z8 table-responsive">
            <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
              <!-- Progress Column -->
              <ng-container matColumnDef="sys_vc_description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción </th>
                <td style="width: 80%;" mat-cell *matCellDef="let row"> {{row.sys_vc_description}} </td>
              </ng-container>

             
              <ng-container matColumnDef="opcion">
                <th style="width: 20%; text-align: center;" mat-header-cell *matHeaderCellDef> Opciones</th>
                <td style="text-align: center;" mat-cell *matCellDef="let element">
                  <a (click)="edit(element)" class="pr-2"><i class="fa fa-edit"></i> Editar</a>
                  <a (click)="delete(element)" class="pr-2"><i class="fa fa-remove"></i> Eliminar</a>
                </td>
              </ng-container>

          
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
               ></tr>

      
              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
              </tr>
              
            </table>

            <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons>
            </mat-paginator>
          </div>

 
        </div>
      </div>

    </fieldset>
  </div>
</div>
